import $ from "jquery";
import { showMessage } from "./main";
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "contactIndex")
        return;
    $("#btnSendContact").on("click", function (e) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        e.preventDefault();
        var $form = $(".zuba-contact-form");
        var turnstileToken = String((_a = $form.find('input[name="cf-turnstile-response"]').val()) !== null && _a !== void 0 ? _a : "").trim();
        var payload = {
            fullName: String((_b = $("#FullName").val()) !== null && _b !== void 0 ? _b : "").trim(),
            email: String((_c = $("#Email").val()) !== null && _c !== void 0 ? _c : "").trim(),
            serviceId: String((_d = $("#ServiceId").val()) !== null && _d !== void 0 ? _d : "").trim(),
            message: String((_e = $("#Message").val()) !== null && _e !== void 0 ? _e : "").trim(),
            // anti-bot
            website: String((_f = $form.find('input[name="website"]').val()) !== null && _f !== void 0 ? _f : ""), // honeypot (nemusí byť trim)
            ts: Number(String((_g = $form.find('input[name="ts"]').val()) !== null && _g !== void 0 ? _g : "").trim() || "0"),
            turnstileToken: turnstileToken
        };
        // (voliteľné) rýchla klientská kontrola
        if (!payload.fullName || !payload.email || !payload.serviceId || !payload.message) {
            showMessage("Vyplň prosím všetky polia.");
            return;
        }
        // Turnstile token musí byť prítomný
        if (!payload.turnstileToken) {
            showMessage("Prosím potvrďte, že nie ste robot, a skúste znova.", "Overenie");
            return;
        }
        try {
            var request = $.ajax({
                url: "/contact/send",
                method: "POST",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(payload),
                beforeSend: function () {
                    $('#spinnerContainer').removeClass('d-none');
                },
                complete: function () {
                    $('#spinnerContainer').addClass('d-none');
                }
            });
            request.done(function (res) {
                if (res.error == true) {
                    showMessage(res.message, "Chyba!");
                }
                else {
                    showMessage(res.message);
                }
                // reset Turnstile, aby sa dalo odoslať znova bez refreshu
                // (existuje len keď je načítaný turnstile script)
                var w = window;
                if (w.turnstile && typeof w.turnstile.reset === "function") {
                    w.turnstile.reset();
                }
            });
            request.fail(function (jqXHR) {
                console.error(jqXHR);
            });
            // napr. vyčistiť formulár:
            // $("#contactForm")[0].reset();
        }
        catch (xhr) {
            var err = xhr === null || xhr === void 0 ? void 0 : xhr.responseJSON;
            if (err === null || err === void 0 ? void 0 : err.errors) {
                // tu si vieš vypísať chyby k poliam
                console.log(err.errors);
            }
            showMessage((_h = err === null || err === void 0 ? void 0 : err.message) !== null && _h !== void 0 ? _h : "Nastala chyba pri odosielaní.", "Chyba!");
            // reset Turnstile aj pri chybe (token už môže byť “spotrebovaný”)
            var w = window;
            if (w.turnstile && typeof w.turnstile.reset === "function") {
                w.turnstile.reset();
            }
        }
    });
});
//# sourceMappingURL=contactIndex.js.map